import { MenuItem, TextField } from "@mui/material";
import { useEffect } from "react";
import { getSiteIconName } from "../../../../utils/CommonUtils";
import CustomIcon from "../../CustomIcons/CustomIcon";
import classes from "../CustomInputs.module.css";

const SitesSelectInput = (props) => {
  useEffect(() => {
    if (props.handleError) {
      props.handleError({ [props.id]: props.hasError });
    }
  }, [props.value]);

  const handleChange = (event) => {
    const { name, value } = event.target ? event.target : event;
    props.onChange({ [name]: props.list.find((site) => site.id === value)});
  };

  return (
    <div className={classes.customSelectField}>
      <TextField
        fullWidth
        select
        disabled={props.disabled}
        id={props.id}
        name={props.id}
        className={classes.textField}
        //defaultValue={props.value}
        value={props.value}
        onChange={handleChange}
        error={props.isStepSubmitted && props.hasError}
        helperText={
          props.isStepSubmitted && props.hasError ? props.errorMessage : ""
        }
        InputLabelProps={{ shrink: true }}
        InputProps={{
          classes: {
            notchedOutline: classes.filed,
          },
        }}
        FormHelperTextProps={{
          classes: {
            error: classes.error,
          },
        }}
        SelectProps={{
          renderValue: (siteId) => {
            let site = props.list?.find((site) => site.id === siteId);
            if (site) {
              return (
                <MenuItem>
                  <CustomIcon
                    className={classes.siteIcon}
                    iconName={getSiteIconName(site.clientId)}
                  />
                  <div className={classes.cardInfo}>
                    <span className={classes.siteName}>{site.displayName}</span>
                    <span className={classes.siteAddress}>{site.address}</span>
                  </div>
                </MenuItem>
              );
            }
          },
          MenuProps: {
            classes: {
              list: classes.menuPaper,
            },
          },
        }}
      >
        {props.list &&
          props.list.map((site) => {
            return (
              <MenuItem className={classes.customSelectField} key={site.id} value={site.id}>
                <CustomIcon
                  className={classes.siteIcon}
                  iconName={getSiteIconName(site.clientId)}
                />
                <div className={classes.cardInfo}>
                  <span className={classes.siteName}>{site.displayName}</span>
                  <span className={classes.siteAddress}>{site.address}</span>
                </div>
              </MenuItem>
            );
          })}
      </TextField>
    </div>
  );
};

export default SitesSelectInput;
